var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreenOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9,15H5.71V7.34H14.6l2.07-2.08H5.48A1.85,1.85,0,0,0,3.63,7.11v8.15a1.85,1.85,0,0,0,.64,1.4H2v2.08H3.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.36,15.26V7.11A1.8,1.8,0,0,0,20,6L18.29,7.77V15H11l-3.7,3.7H22V16.66H19.72A1.85,1.85,0,0,0,20.36,15.26Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: 10.96,
    width: 26.19,
    height: 2.08,
    transform: "translate(-4.97 12) rotate(-45.02)",
    fill: "#ff9300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreenOff);
export default __webpack_public_path__ + "static/media/share-screen-off.6a7f72bb82801c7c444d3742ab5836b7.svg";
export { ForwardRef as ReactComponent };